import { render } from "./PartnerLogo.vue?vue&type=template&id=618a9032&ts=true"
import script from "./PartnerLogo.vue?vue&type=script&lang=ts"
export * from "./PartnerLogo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__